import { render, staticRenderFns } from "./ShareManagementCatalogue.vue?vue&type=template&id=8fd449e4"
import script from "./courseWare.js?vue&type=script&lang=js&external"
export * from "./courseWare.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports